export default "__VITE_ASSET__ebb12422__"